import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPptAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7418_53861)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.8 0C2.14903 0 0 2.14903 0 4.8V19.2C0 21.851 2.14903 24 4.8 24H19.2C21.851 24 24 21.851 24 19.2V6.99411C24 6.35759 23.7471 5.74714 23.2971 5.29706L18.7029 0.702944C18.2529 0.252856 17.6424 0 17.0059 0H4.8ZM3.3 9C3.3 8.66863 3.56863 8.4 3.9 8.4H4.8H19.2H20.1C20.4314 8.4 20.7 8.66863 20.7 9C20.7 9.33137 20.4314 9.6 20.1 9.6H19.8V16.2C19.8 17.5255 18.7255 18.6 17.4 18.6H12.6V19.3605C12.9587 19.568 13.2 19.9558 13.2 20.4C13.2 21.0627 12.6627 21.6 12 21.6C11.3373 21.6 10.8 21.0627 10.8 20.4C10.8 19.9558 11.0413 19.568 11.4 19.3605V18.6H6.6C5.27452 18.6 4.2 17.5255 4.2 16.2V9.6H3.9C3.56863 9.6 3.3 9.33137 3.3 9ZM5.4 9.6H18.6V16.2C18.6 16.8627 18.0627 17.4 17.4 17.4H6.6C5.93726 17.4 5.4 16.8627 5.4 16.2V9.6ZM13.8 11.4C13.4686 11.4 13.2 11.6686 13.2 12C13.2 12.3314 13.4686 12.6 13.8 12.6H16.2C16.5314 12.6 16.8 12.3314 16.8 12C16.8 11.6686 16.5314 11.4 16.2 11.4H13.8ZM13.2 14.4C13.2 14.0686 13.4686 13.8 13.8 13.8H14.4C14.7314 13.8 15 14.0686 15 14.4C15 14.7314 14.7314 15 14.4 15H13.8C13.4686 15 13.2 14.7314 13.2 14.4ZM7.66663 11.2045C8.06131 10.9408 8.52532 10.8 9 10.8V13.2H11.4C11.4 13.6747 11.2592 14.1387 10.9955 14.5334C10.7318 14.928 10.357 15.2357 9.91844 15.4173C9.4799 15.599 8.99734 15.6465 8.53178 15.5539C8.06623 15.4613 7.63859 15.2327 7.30294 14.8971C6.9673 14.5614 6.73872 14.1338 6.64612 13.6682C6.55351 13.2027 6.60104 12.7201 6.78269 12.2816C6.96434 11.843 7.27195 11.4682 7.66663 11.2045Z",
			fill: "#4F49BA"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7418_53861",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPptAttachment;
